module.exports = __webpack_public_path__ + "static/media/cq_alert b.d2167d8c.svg";